(() => {
  const NAV_SELECTOR = '[data-sub-collections-nav]';

  function updateOverflow(nav) {
    if (!nav) return;
    nav.toggleAttribute('data-overflowing', nav.scrollWidth > nav.clientWidth + 2);
  }

  function bindNav(nav) {
    if (nav.dataset.subCollectionsBound === 'true') return;
    nav.dataset.subCollectionsBound = 'true';
    updateOverflow(nav);

    if (typeof ResizeObserver === 'function') {
      const ro = new ResizeObserver(() => updateOverflow(nav));
      ro.observe(nav);
    } else {
      window.addEventListener('resize', () => updateOverflow(nav), { passive: true });
    }

    nav.addEventListener('scroll', () => updateOverflow(nav), { passive: true });
  }

  function initAll(root) {
    const scope = root instanceof Document || root instanceof HTMLElement ? root : document;
    scope.querySelectorAll(NAV_SELECTOR).forEach(bindNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!(section instanceof HTMLElement)) return;
    initAll(section);
  });
})();
